import { LoginCookieHandler } from './LoginCookieHandler';

const storageKey = 'self-service-session-id';

/**
 * Identifies one browser tab's visit to the check-in portal, so step
 * submissions can be grouped into visits in reporting. Undefined during SSR.
 */
export const getSelfServiceSessionId = (): string | undefined => {
    if (typeof window === 'undefined') {
        return undefined;
    }
    try {
        const existing = window.sessionStorage.getItem(storageKey);
        if (existing) {
            return existing;
        }
        const sessionId = window.crypto.randomUUID();
        window.sessionStorage.setItem(storageKey, sessionId);
        return sessionId;
    } catch {
        return undefined;
    }
};

/**
 * Call before navigating to `/logout`. Without this a branch tablet reports the
 * next customer's check-in under the previous customer's session and branch.
 */
export const clearSelfServiceSession = (): void => {
    LoginCookieHandler.clearLoginAtBranchCode();
    if (typeof window === 'undefined') {
        return;
    }
    try {
        window.sessionStorage.removeItem(storageKey);
    } catch {
        return;
    }
};
